<script lang="ts">
  import { AlertTag, Icon } from '$shared/components';
  import type { AlertAction } from '$shared/models/AlertAction';
  import { onMount } from 'svelte';

  interface Props {
    alerts?: Array<AlertAction>;
    row: any;
    onclickAlert?: (payload: { row: any; alert: AlertAction }) => void;
  }

  let { alerts = [], row, onclickAlert }: Props = $props();

  let displayShowMoreOption = $state(false);

  let displayAlerts = $derived(displayShowMoreOption ? [alerts?.first()] : alerts);

  onMount(() => {
    displayShowMoreOption = alerts?.length > 1;
  });

  const onClickAlert = (alert: AlertAction): void => {
    onclickAlert?.({ row, alert });
  };

  const onClickDropDown = () => {
    displayShowMoreOption = false;
  };
</script>

<div class="alert">
  <div class="alert-cell-wrap">
    {#each displayAlerts as alert}
      <div class="alert-cell">
        <AlertTag label={alert.label} onclick={() => onClickAlert(alert)} />
      </div>
    {/each}
  </div>
  {#if displayShowMoreOption}
    <div class="alert-cell-wrap">
      <button class="comp-alert-showmore-tag" onclick={onClickDropDown}>
        <div class="icon">
          <Icon value="icon-chevron-down" />
        </div>
        <div class="text">
          {`${alerts?.length - 1} More Issues`}
        </div>
      </button>
    </div>
  {/if}
</div>

<style>
  .alert-cell-wrap {
    align-items: center;
    flex-wrap: wrap;
    line-height: 40px;
  }
  .comp-alert-showmore-tag {
    height: 32px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: var(--black);
    display: inline-flex;
    align-items: center;
    background-color: var(--yellow-light);
    padding: 0 16px;
    border-radius: 4px;
  }
  .comp-alert-showmore-tag:hover {
    background-color: var(--yellow-hover);
  }
  .comp-alert-showmore-tag .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .comp-alert-showmore-tag .icon {
    margin-right: 8px;
  }
</style>
